module.exports = __webpack_public_path__ + "static/media/drumheller-13.4faa03a9.jpg";